import { createSimpleSelector } from '../selector-utils';
import { createActionsWithReducer } from '../utils';
import { createSingleEntityAdapter } from './adapter';
import {
  SingleEntityState,
  SingleEntityStoreCustomActions,
  SingleEntityStoreOptions,
} from './types';

export function createSingleEntityStore<T extends object>() {
  return <U extends SingleEntityStoreOptions<T>>(namespace: string, options?: U) => {
    const ns = `entity/${namespace}`;

    const baseSelector = createSimpleSelector(
      (root: any) => <SingleEntityState<T>>root[ns],
      state => state,
    );

    const { adapter, initialState, selectors, defaultActions } = createSingleEntityAdapter<T>(
      baseSelector,
      ns,
    );

    const mergedActions = <typeof defaultActions & SingleEntityStoreCustomActions<U>>{
      ...defaultActions,
      ...options?.customActions!(adapter),
    };

    const { actions, reducer } = createActionsWithReducer(namespace, initialState, mergedActions);
    return {
      namespace: ns,
      selectors,
      actions,
      reducer,
    };
  };
}
